import styled from 'styled-components';

const YadoItemContentView = styled.div`
  flex: 1 1 auto;
  position: relative;
  padding: 1em 0.5em 0 1em;
  padding-left: 1em;
  display: flex;
  flex-direction: column;
  justify-content: space-between; 
  .title {
    margin: 0;
    margin-bottom: 0.25em;
    padding: 0;
    color: var(--gray900);
    font-size: 1em;
    font-weight: 600;
    line-height: 1.4em;
  }
  .title-en {
    font-size: 10px;
    font-weight: 600;
    line-height: 1.4em;
    padding: 0;
    margin: 0;
    color: var(--gray600);
  }
  .resort-section-title {
    color: var(--gray900);
    padding: 0;
    margin-bottom: 4px;
    font-size: 12px;
    font-weight: bold;
  }
`;

export default YadoItemContentView;
